import { NgModule } from '@angular/core';
import {
  AlertModule,
  FileInputComponent,
  SelectInputComponent,
  TextInputComponent,
  TextareaInputComponent,
  ButtonModule,
  CityInputComponent,
  NumberInputComponent,
  DateInputComponent,
  MultiselectInputComponent,
  ParagraphPipeModule,
  OtpInputComponent,
  PasswordInputComponent,
  ModalModule,
  TooltipDirective,
  PaginatorModule,
  TabsModule,
  IconButtonModule,
  TimeInputComponent,
  TableModule,
  SwitchInputComponent,
  FiltersModule,
  TimelineModule,
  LgDragDropFilesDirective,
  TagComponent,
  PaginationComponent,
  NavbarModule,
  SidebarModule,
  ModalDialogComponent,
  DropdownModule,
  StepperModule,
  IndicativeInputComponent,
  ChipComponent
} from 'logical-growth-components';

@NgModule({
  imports: [
    FileInputComponent,
    SelectInputComponent,
    AlertModule,
    TextareaInputComponent,
    TextInputComponent,
    ButtonModule,
    CityInputComponent,
    NumberInputComponent,
    DateInputComponent,
    MultiselectInputComponent,
    ParagraphPipeModule,
    OtpInputComponent,
    PasswordInputComponent,
    ModalModule,
    TabsModule,
    TooltipDirective,
    PaginatorModule,
    IconButtonModule,
    TimeInputComponent,
    TableModule,
    SwitchInputComponent,
    FiltersModule,
    TimelineModule,
    LgDragDropFilesDirective,
    TagComponent,
    PaginationComponent,
    NavbarModule,
    SidebarModule,
    ModalDialogComponent,
    DropdownModule,
    StepperModule,
    IndicativeInputComponent,
    ChipComponent
  ],
  exports: [
    FileInputComponent,
    SelectInputComponent,
    AlertModule,
    TextareaInputComponent,
    TextInputComponent,
    ButtonModule,
    CityInputComponent,
    NumberInputComponent,
    DateInputComponent,
    MultiselectInputComponent,
    ParagraphPipeModule,
    OtpInputComponent,
    PasswordInputComponent,
    ModalModule,
    TabsModule,
    TooltipDirective,
    PaginatorModule,
    IconButtonModule,
    TimeInputComponent,
    TableModule,
    SwitchInputComponent,
    FiltersModule,
    TimelineModule,
    LgDragDropFilesDirective,
    TagComponent,
    PaginationComponent,
    NavbarModule,
    SidebarModule,
    ModalDialogComponent,
    DropdownModule,
    StepperModule,
    IndicativeInputComponent,
    ChipComponent
  ]
})
export class LogicalGrowthComponentsModule { }
